import { api } from "../apis/axiosInstance";

export const Notifications = {
  /**
   * Fetch notifications with pagination
   * @param {number} perPage - Number of notifications per page (default: 10)
   * @param {number} page - Page number (default: 1)
   * @return {Promise} Resolves with notification data array
   * @throws {Error} When request fails
   */
  getNotifications: async ({ perPage = 10, page = 1 } = {}, signal) => {
    try {
      const res = await api.get("/notifications", {
        params: { perPage, page },
        signal,
        headers: {
          "Cache-Control": "no-cache, no-store, must-revalidate",
          Pragma: "no-cache",
        },
      });
      return res.data.data || [];
    } catch (err) {
      if (err.name === "CanceledError") return []; // ignore cancel
      console.error("Failed to fetch notifications", err);
      throw new Error(err.response?.data?.message);
    }
  },

  /**
   * Mark a notification as read/unread
   * @param {string} notificationId - ID of the notification
   * @param {"read"|"unread"} action - Action to perform (default: "read")
   * @returns {Promise<boolean>} True if successful
   * @throws {Error} When request fails
   */
  markAsRead: async (notificationId, action = "read") => {
    try {
      await api.patch(`/notifications/${notificationId}`, { action });
      return true;
    } catch (err) {
      console.error("Failed to update notification state", err);
      throw new Error(
        err.response?.data?.message || "Failed to update notification",
      );
    }
  },

  /**
   * Delete a notification
   * @param {string} notificationId - ID of the notification to delete
   * @returns {Promise<boolean>} True if successful
   * @throws {Error} When request fails
   */
  deleteNotification: async (notificationId) => {
    try {
      await api.delete(`/notifications/${notificationId}`);
      return true;
    } catch (err) {
      console.error("Failed to delete notification", err);
      throw new Error(
        err.response?.data?.message || "Failed to delete notification",
      );
    }
  },
};
